import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import DinardStickyCTA from "./DinardStickyCTA";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Layout = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pt-[88px]">{children}</main>
      <Footer />
      <DinardStickyCTA />
    </div>
  );
};

export default Layout;
